// Adapted from davinci-elections apps/web/src/theme/recipes/tooltip.ts @ 6e23f58
import { tooltipAnatomy } from '@chakra-ui/react/anatomy'
import { defineSlotRecipe } from '@chakra-ui/react'

const baseStyle = {
  boxShadow: 'raised',
  border: '1px solid',
  borderColor: 'border',
  px: 2,
  py: 1,
  bgColor: 'bg.panel',
  color: 'fg',
}

export const Tooltip = defineSlotRecipe({
  slots: tooltipAnatomy.keys(),
  base: {
    content: baseStyle,
  },
})
